<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}}</h5>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"            :active="section === ''"           >Detail Issue</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>

export default {
  name: 'issue_detail',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[3] || '',
      loaded: false,
    };
  },
  created() {
    const { issueId } = this.$route.params;
    this.$store.commit('issues/SET_DETAIL_ID', issueId);
    this.$store.dispatch('issues/LOAD_DETAIL_DATA');
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'issues', name: 'Issue' },
      { to: issueId, name: 'Detail' },
    ]);
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['issues/get_detail_data'];
    },
    displayName() {
      return this.detailedInfo.title;
    },
  },
  watch: {
    section(newSection) {
      const { issueId } = this.$route.params;
      this.$router.push(`issues/${issueId}/${newSection}`);
    },
  },
};
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/pages/issues/DetailIndex.vue